import React from 'react';
import { getBezierPath, EdgeLabelRenderer } from '@xyflow/react';

export default function CustomEdge({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  style = {},
  markerEnd,
  setEdges
}) {
  const [edgePath] = getBezierPath({
    sourceX,
    sourceY,
    targetX,
    targetY,
    curvature: 0.3, // Make lines more curved for better visibility
  });

  // Delete handler
  const handleDelete = (e) => {
    e.stopPropagation();
    setEdges(eds => eds.filter(edge => edge.id !== id));
  };

  return (
    <>
      <path
        id={id}
        style={{
          ...style,
          stroke: '#128C7E',
          strokeWidth: 2,
          fill: 'none',
          strokeDasharray: 'none'
        }}
        className="react-flow__edge-path"
        d={edgePath}
        markerEnd={markerEnd}
      />
      <EdgeLabelRenderer>
        <div
          style={{
            position: 'absolute',
            transform: `translate(-50%, -50%) translate(${(sourceX + targetX) / 2}px, ${(sourceY + targetY) / 2}px)`,
            pointerEvents: 'all',
            zIndex: 1,
          }}
        >
          <button
            onClick={handleDelete}
            style={{
              background: '#ff4d4f',
              color: '#fff',
              border: 'none',
              borderRadius: '50%',
              width: 24,
              height: 24,
              cursor: 'pointer',
              fontWeight: 'bold',
              fontSize: 16,
              lineHeight: '24px',
              boxShadow: '0 1px 4px rgba(0,0,0,0.15)'
            }}
            title="Cancel connection"
          >
            🗙
          </button>
        </div>
      </EdgeLabelRenderer>
    </>
  );
} 